<template>
    <div>
        <div>
            <el-row :gutter="12">
                <el-col :span="24">
                    <div style="width: 100%;text-align: right;">
                        <el-input type="text" style="width:300px;margin-left: 3px;" v-model="condition.sn"
                                  placeholder="请输入sn">
                            <el-button slot="append" icon="el-icon-search" @click="condition.pageId=1;getTableData()">搜索</el-button>
                        </el-input>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 15px;">
            <el-table ref="multipleTable"
                      :data="tableData"
                      style="width: 100%"
                      element-loading-text="数据正在加载中"
                      :header-cell-style="headClass"
                      :row-style="rowClass">
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="applicationId" label="开单号" sortable></el-table-column>
                <el-table-column prop="sn" label="设备sn号"></el-table-column>
                <el-table-column prop="nickname" label="安装师傅"></el-table-column>
                <el-table-column label="安装时间" prop="posttime" :formatter="dateFormat"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="showDetail(scope.row)">查看详细</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background
				    	style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
				        @size-change="handleSizeChange"
				        @current-change="handleCurrentChange"
				        :current-page="condition.pageId"
				        :page-sizes="[10, 50, 100, 200]"
				        :page-size="condition.size"
				        layout="total, sizes, prev, pager, next, jumper"
				        :total="total">
				  </el-pagination>
            <el-dialog :visible.sync="detailVisible" title="安装记录详情">
                <el-row>
                    <el-col :span="12">
                        <el-form>
                            <el-form-item label="开单号">
                                {{ installLogDetail.applicationId }}
                            </el-form-item>
                            <el-form-item label="设备序列号">
                                {{ installLogDetail.sn }}
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="12">
                        <el-form>
                            <el-form-item label="安装师傅">
                                {{ installLogDetail.nickname }}
                            </el-form-item>
                            <el-form-item label="安装时间">
                                {{ getStandardDate(new Date(installLogDetail.posttime)) }}
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form inline="" v-if="images.length > 0">
                        <el-form-item>
                            <el-image class="detail-image" :src="images[0]" :preview-src-list="images" />
                        </el-form-item>
                        <el-form-item>
                            <el-image class="detail-image" :src="images[1]" :preview-src-list="images" />
                        </el-form-item>
                        <el-form-item>
                            <el-image class="detail-image" :src="images[2]" :preview-src-list="images" />
                        </el-form-item>
                    </el-form>

                </el-row>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "installation.vue",
        data() {
            return {
                tableData: [],
                condition: {
                    sn: '',
                    pageId: 1,
                    size: 10
                },
                total: 0,
                detailVisible: false,
                installLogDetail: {},
                images: [],
            }
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            handleSizeChange(val) {
                this.condition.size = val;
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.condition.pageId = val;
                this.getTableData();
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            getTableData() {
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '获取表格数据中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                setTimeout(() => {
                    loading.close();
                }, 3000);
                axios.get(this.$store.getters.getApiValue + '/application/listInstallLogByAdmin.do', {
                    params: this.condition
                }).then(function(response) {
                    loading.close();
                    var data = response.data;
                    if (data.status == "200") {
                        thiz.total = data.totalCount;
                        thiz.tableData = data.data;
                    } else {
                        thiz.$message.error(data.message);
                    }
                }).catch(function(error) {
                    loading.close();
                    thiz.$message.error("系统异常，请与管理员联系!");
                    console.log(error);
                });
            },

            showDetail(installLog) {
                this.installLogDetail = installLog;
                if (installLog.installImages !== '') {
                    this.images = installLog.installImages.split(",");
                } else {
                    this.images = []
                }
                this.detailVisible = true;
            },

            dateFormat(row, column, cellValue, index) {
                var str = cellValue;
                if (str == null || str == "") {
                    return "";
                } else {
                    return this.getStandardDate(new Date(str));
                }
            },
            getStandardDate(val) {
                var year = val.getFullYear();
                var month = val.getMonth() + 1;
                var day = val.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                return year + "-" + month + "-" + day;
            },
        }
    }
</script>

<style scoped>
    .detail-image {
        width: 120px;
        height: 120px;
    }
</style>